import { useMemo } from "react";
import {
  computeMessageLimitState,
  type MessageLimitState,
} from "@/lib/messageLimits";
import { toPlainText } from "@/lib/markdown";

const EMPTY_STATE: MessageLimitState = computeMessageLimitState({
  plainText: "",
  html: "",
});

export function useRtfMessageLimits(value: string): MessageLimitState {
  return useMemo(() => {
    const plainText = toPlainText(value);
    if (!plainText.trim()) {
      return EMPTY_STATE;
    }

    // plainText: stripped of markdown syntax (for user-facing char count)
    // html: original markdown value (for encrypted size prediction)
    return computeMessageLimitState({ plainText, html: value });
  }, [value]);
}
